import React, {useState, useRef} from 'react'
import { Stage, Layer, Image, Rect, Circle } from 'react-konva';
import useImage from 'use-image'

import Canvas from './config/canvas'
import Tools from './components/Tools'
import Header from './components/Header'
import './App.css';

function App() {
  const [zoomBG, setZoomBG] = useState({
    width: Canvas.defaultWidth,
    height: Canvas.defaultHeight,
    uploadedLogo: null,
    logoHeight: null,
    logoWidth: null,
    brandColor: "#311b92",
    backgroundImage: "https://images.unsplash.com/photo-1505820996465-b8bf9918eb60?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=640&q=100"
  })

  const stageRef = useRef(null)
  const [background] = useImage(zoomBG.backgroundImage, 'Anonymous')
  const [logo] = useImage(zoomBG.uploadedLogo, 'Anonymous')

  function handleChange(event) {
    event.preventDefault()
    const { name, value, files, src } = event.target
    if (files && files.length > 0) {
      setZoomBG(prevState => (
        {
          ...prevState,
          uploadedLogo: URL.createObjectURL(files[0])
        }
      ))
      const i = new window.Image();
      i.onload = function() {
        const imageDimensions = {
            height: i.height,
            width: i.width
        };
        if (imageDimensions.height !== imageDimensions.width) {
          return alert("Please upload square brand logo, ie. 250 x 250px")
        } else {
          setZoomBG(prevState => (
            { 
              ...prevState,
              logoHeight: imageDimensions.height,
              logoWidth: imageDimensions.width
            }
          ))
        }
        
      }
      i.src = URL.createObjectURL(files[0]);
    }
    setZoomBG(prevState => (
      {
        ...prevState,
        backgroundImage: name === 'background' ? src : zoomBG.backgroundImage,
        brandColor: name === 'brandcolor' ? value : zoomBG.brandColor
      }
    ))
  }

  function downloadURI(uri, name) {
    const link = document.createElement('a');
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link)
  }

  function handleDownload() {
    const dataURL = stageRef.current.toDataURL({ pixelRatio: 3 });
    downloadURI(dataURL, 'Zoom-Background.png');
  }


  return (
    <div className="App">
      <Header />
      <main>
        <div className="main--tools">
          <Tools 
            brandColor={zoomBG.brandColor}
            handleChange={handleChange}
          />
        </div>
    
        <div className="main--canvas">
          <h2>Preview</h2>
          <div className="stage-container" >
            <Stage width={zoomBG.width} height={zoomBG.height} ref={stageRef} >
              <Layer>
                <Image 
                  x={0}
                  y={0}
                  width={zoomBG.width}
                  height={zoomBG.height}
                  image={background}
                />
                <Rect
                  x={0}
                  y={0}
                  width={zoomBG.width}
                  height={Canvas.barHeight}
                  fill={zoomBG.brandColor}
                  shadowBlur={2}
                />
                { zoomBG.uploadedLogo !== "" &&  <Circle
                  x={zoomBG.width * 0.8} 
                  y={zoomBG.height * 0.05} 
                  radius={Canvas.logoRadius}
                  fillPatternImage={ logo }
                  fillPatternScaleY={ (Canvas.logoRadius / 2) / zoomBG.logoHeight  }
                  fillPatternScaleX={ (Canvas.logoRadius / 2) / zoomBG.logoWidth  }
                  fillPatternRepeat={'no-repeat'}
                />} 
              </Layer>
            </Stage>
          </div>       
          <button className="download-btn" onClick={handleDownload}>Grab my background ✌️<span><small> (it's free!)</small></span></button>
        </div> 
      </main>
    </div>
  );
}

export default App;
